module.exports = __webpack_public_path__ + "static/media/LogTriple.0aee86b4.mp3";